import { BfxMomentPipe } from "./pipes/bfx-moment.pipe";
import { CapitalizePipe } from "./pipes/bfx-capitalize.pipe";
import { IsArrayPipe } from "./is-array.pipe";
import { NgModule } from "@angular/core";
import { TimerFormatPipe } from "./pipes/bfx-timer-format.pipe";
import { TranslateStatusPipe } from "./pipes/bfx-translate-status.pipe";

@NgModule({
  imports: [],
  providers: [BfxMomentPipe, CapitalizePipe, IsArrayPipe, TimerFormatPipe, TranslateStatusPipe],
  declarations: [BfxMomentPipe, CapitalizePipe, IsArrayPipe, TimerFormatPipe, TranslateStatusPipe],
  exports: [BfxMomentPipe, CapitalizePipe, IsArrayPipe, TimerFormatPipe, TranslateStatusPipe],
})
export class BfxPipeModule {}
